import { AxiosResponse } from "axios";
import { call, delay, put, select, takeLatest } from "redux-saga/effects";
import { toast } from "sonner";
import CatchBlockFunction from "../../../../components/hooks/CatchBlockFunction";
import { get, post } from "../../../../utils/request";

import { actions } from "./slice";
import { selectPageNo, selectPageSize } from "./selector";

export function* doGetListRequest() {
  yield delay(500);
  try {
    yield put(actions.setLoading(true));
    const pageNo: number = yield select(selectPageNo);
    const pageSize: number = yield select(selectPageSize);
    const response: AxiosResponse = yield call(
      get,
      `admin/retailers/product/image/list?pageNo=${pageNo}&pageSize=${pageSize}`
    );
    yield put(actions.setLoading(false));
    if (response && !response.data) {
      toast.error(response.data.message);
      return;
    }
    yield put(actions.setList(response.data.data.results));
    yield put(actions.setTotalRow(response.data.data.meta ? response.data.data.meta.totalPages : 0));
  } catch (error: any) {
    yield put(actions.setLoading(false));
    CatchBlockFunction(error);
  }
}
export function* uploadDocumentRequest(action: {
  payload: { fileName: string; callback: any };
}) {
  try {
    const response: AxiosResponse = yield call(
      post,
      `admin/retailers/product/images/upload`,
      {
        file: action.payload.fileName,
      }
    );
    if (!response.status) {
      toast.error(response.data.message);
    }
    yield call(action?.payload?.callback());
  } catch (error: any) {
    CatchBlockFunction(error);
  }
}

export function* ImageUploadRepoSaga() {
  yield takeLatest(actions.doGetList, doGetListRequest);
  yield takeLatest(actions.uploadImage, uploadDocumentRequest);
}
